import React from "react";
import { Box, Typography, TextField, Select, MenuItem, FormControl, FormHelperText, Stack } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EventIcon from "@mui/icons-material/Event";
import NotesIcon from "@mui/icons-material/Notes";
import { tituloLabelSx } from "./estilos";

/**
 * Sección de asignación del formulario de inventario: selector de preparador,
 * fecha límite y observaciones. No maneja estado propio: recibe valores y
 * callbacks por props.
 */
const SeccionAsignacion = ({
    preparadorId,
    usuariosOptions,
    cargandoUsuarios,
    onChangePreparador,
    onBlurPreparador,
    mostrarErrorPreparador,
    errorPreparador,
    fechaLimite,
    onChangeFechaLimite,
    observaciones,
    onChangeObservaciones,
}) => (
    <>
        <Box>
            <Typography variant="body2" sx={tituloLabelSx}>
                <PersonIcon sx={{ fontSize: 18 }} /> Preparador asignado *
            </Typography>
            <FormControl fullWidth error={Boolean(mostrarErrorPreparador && errorPreparador)}>
                <Select
                    displayEmpty
                    value={preparadorId}
                    onChange={onChangePreparador}
                    onBlur={onBlurPreparador}
                    disabled={cargandoUsuarios}
                    sx={{ backgroundColor: "#fff" }}
                >
                    <MenuItem value="" disabled>
                        {cargandoUsuarios ? "Cargando preparadores..." : "Selecciona un preparador"}
                    </MenuItem>
                    {usuariosOptions.map((opcion) => (
                        <MenuItem key={opcion.value} value={opcion.value}>{opcion.label}</MenuItem>
                    ))}
                </Select>
                {mostrarErrorPreparador && errorPreparador && <FormHelperText>{errorPreparador}</FormHelperText>}
            </FormControl>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Box sx={{ flex: 1 }}>
                <Typography variant="body2" sx={tituloLabelSx}>
                    <EventIcon sx={{ fontSize: 18 }} /> Fecha límite
                </Typography>
                <TextField
                    type="date"
                    fullWidth
                    value={fechaLimite}
                    onChange={onChangeFechaLimite}
                    sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                />
            </Box>
            <Box sx={{ flex: 2 }}>
                <Typography variant="body2" sx={tituloLabelSx}>
                    <NotesIcon sx={{ fontSize: 18 }} /> Observaciones
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={1}
                    placeholder="Notas para el preparador (opcional)"
                    value={observaciones}
                    onChange={onChangeObservaciones}
                    sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "#fff" } }}
                />
            </Box>
        </Stack>
    </>
);

export default SeccionAsignacion;
